export const MAX_LIST_START = 999999999;

const clamp = (n: number) => Math.min(Math.max(n, 0), MAX_LIST_START);

const startInDomain = (value: unknown): number => {
	if (typeof value === "string") return /^-?\d+$/.test(value.trim()) ? clamp(Number(value)) : 1;
	return typeof value === "number" && Number.isInteger(value) ? clamp(value) : 1;
};

export default startInDomain;
